module.exports = __webpack_public_path__ + "img/chinesecompany176.f5cc28ab.png";